export default /(^\+\d{2}|^\+\d{2}(0)|^\+\d{2}(0)|^00\d{2}|^0)(\d{9}$|6-\d{8}$|\d{2}-\d{7}$|\d{3}-\d{6}$)/;
